import { Description, Caption, Button } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import Icon from '@/components/Icon'
import { useCityPage } from '@/context/CityPageContext'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { flexCenter, gap, marginBottom } from '@/shared-styles/styles.css'
import { handleNewListingsAlertClick } from '@/utils/tracking/eventsHandlers'

import { box } from '../../styles.css'

export const EmptyFiltersBox: React.FC = () => {
  const { closeModal } = useModal()
  const { t } = useTranslation()
  const { openFilterModal } = useCityPage()

  return (
    <div className={box}>
      <div className={[flexCenter, gap.m].join(' ')}>
        <Icon.Info className={sprinkles({ alignSelf: 'flex-start', flexShrink: 0 })} height={20} width={20} />

        <div>
          <Description strong className={marginBottom.xs}>
            {t('save-search:Modal_NoFilterBanner_Title')}
          </Description>
          <Caption>{t('save-search:Modal_NoFilterBanner_Description')}</Caption>
        </div>

        <Button
          className={sprinkles({ flexShrink: 0, padding: 's' })}
          label={t('save-search:Modal_NoFilterBanner_CTA')}
          styleVariant="tertiary"
          onClick={() => {
            handleNewListingsAlertClick('OpenFilterModal')
            closeModal()
            openFilterModal()
          }}
        />
      </div>
    </div>
  )
}
